/**
 * Cart Recommendations Unified JavaScript
 * Dynamically shows/hides the fallback carousel based on cart state
 */

function initCartRecommendationsUnified() {
  const elements = document.querySelectorAll('.cart-recommendations-unified');
  
  if (elements.length === 0) {
    return;
  }
  
  elements.forEach(element => {
    // Get settings from data attributes
    const maxItemsForIndividual = parseInt(element.dataset.maxItems) || 3;
    const pairsEnabled = element.dataset.pairsEnabled === 'true';
    const fallbackEnabled = element.dataset.fallbackEnabled === 'true';
    const hasPairsRecommendations = element.dataset.hasPairsRecommendations === 'true';
    
    function shouldShowFallback(cartItemsCount, hasPairsInCurrentCart) {
      // Show fallback if:
      // 1. Cart items exceed threshold, OR
      // 2. Cart is empty, OR  
      // 3. No items in cart have pairs recommendations
      const shouldShow = ((cartItemsCount > maxItemsForIndividual || cartItemsCount === 0 || !hasPairsInCurrentCart) && fallbackEnabled);
      return shouldShow;
    }
    
    function updateVisibility(cartItemsCount, hasPairsInCurrentCart) {
      const shouldShow = shouldShowFallback(cartItemsCount, hasPairsInCurrentCart);
      
      if (shouldShow) {
        element.style.display = 'block';
        element.setAttribute('aria-hidden', 'false');
        element.classList.remove('f-cart-recommendations-hidden');
      } else {
        element.style.display = 'none';
        element.setAttribute('aria-hidden', 'true');
        element.classList.add('f-cart-recommendations-hidden');
      }
    }
    
    async function fetchCartData() {
      try {
        const response = await fetch('/cart.json');
        const cartData = await response.json();
        
        // Count items excluding gift wrap (items with 'gift' in product title)
        const nonGiftItemCount = cartData.items.filter(item => 
          !item.product_title.toLowerCase().includes('gift')
        ).length;
        
        // Use the initial pairs recommendation state from Liquid template
        // This will be updated when cart changes occur via cart update events
        const currentHasPairs = element.dataset.hasPairsRecommendations === 'true';
        updateVisibility(nonGiftItemCount, currentHasPairs);
      } catch (error) {
        console.error('Error fetching cart data:', error);
      }
    }
    
    function handleCartUpdate() {
      // After any cart update, fetch fresh cart data
      fetchCartData();
    }
    
    // Listen for cart updates
    window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    
    // Initial check
    fetchCartData();
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initCartRecommendationsUnified);
